import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const seoApi = createApi({
  reducerPath: "seoApi",
  baseQuery: customFetchBase({ url: "seo" }),
  endpoints: (builder) => ({
    getPagesSeoApi: builder.query({
      query: ({ route }) => ({
        url: route,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetPagesSeoApiQuery } = seoApi;
